import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type ContactLink } from '../types';
import { zodContactLinkSchema } from '../validations';

/**
 * Fetches the most recent contact link for a data-exchange by its DE ID.
 *
 * @param deId - The UUID of the data exchange.
 * @param options - Optional request options (e.g., abort signal).
 * @returns The contact link data.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_contact_link_by_de_id_suppliers__de_id__contact_link_get
 */
export const fetchContactLinkByDataExchangeId = async (
  deId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_CONTACT_LINK_BY_DATA_EXCHANGE_ID(deId), {
      ...options,
      validate: {
        ...options?.validate,
        response: zodContactLinkSchema,
      },
    })
    .json<ContactLink>();
